<template>
  <div>
    <div class="flex flex_w_w">
      <div v-for="(item,index) in list" :key="index" class="w_50p">
        <div class="pos_r flex j_c_c m_10">
          <img :src="item.img" class="w_100p" />
          <div class="t_a_c m_lr_auto pos_a top_100 w_100p c_333 m_t_30">
            <div class="f_s_16">{{item.text}}</div>
            <div class="visuallyhidden f_w_600 f_s_34 m_t_20">{{item.slogan}}</div>
            <div class="f_s_20 f_w_500 l_h_24 m_t_10">{{item.headline}}</div>
            <div class="flex j_c_c m_t_20 f_s_12">
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 四方格
 *
 */
export default {
  name: "CheckeredPattern",
  props: {
    list: {
      type: Array
    }
  }
};
</script>

<style>
</style>